import { useRef, useEffect } from "react";

function VideoComponent({ videoUrl, autoplay = true, loop = true, muted = true, style = {} }) {
    const videoRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            const entry = entries[0];
            const ratio = entry.intersectionRatio;
            const video = videoRef.current;

            if (ratio > 0.85 && video) {
                setTimeout(() => {
                    video.play().catch(error => {
                        console.log("Video play failed:", error);
                    });
                }, 100); // Optional delay (adjust as needed)
            } else if (ratio <= 0.85 && video) {
                video.pause();
            }
        }, { threshold: [0.85] });

        if (containerRef.current) {
            observer.observe(containerRef.current);
        }

        return () => {
            observer.disconnect();
        };
    }, []);

    const defaultStyle = {
        maxWidth: '100%',
        height: 'auto',
        border: '1px solid #292929',
        borderRadius: '8px',
        objectFit: 'contain'
    };

    return (
        <div ref={containerRef}>
            <video
                ref={videoRef}
                src={videoUrl}
                autoPlay={autoplay}
                loop={loop}
                muted={muted}
                playsInline
                style={{ ...defaultStyle, ...style }}
                onError={(e) => {
                    console.error("Video loading error:", e);
                }}
            />
        </div>
    );
}

export default VideoComponent; 